// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"Navigation_NavLink__3oEd8","NavLink__active":"Navigation_NavLink__active__1Wy5a","NavList":"Navigation_NavList__9TP9c","List":"Navigation_List__1EWAG"};